module.exports = __webpack_public_path__ + "img/production-switcher.3c664374.png";